// The tabs of a site share one session cookie, so a change of who acts in one is told to the others.
const channelName = 'tms.session'

// Each tab's own id: a BroadcastChannel skips only the object that sent, not the rest of its tab.
const thisTab = crypto.randomUUID()

/** Tells this site's other tabs that who acts in the session changed, as after an impersonation starts or a new session does. */
export function announceSessionChange(): void {
  if (typeof BroadcastChannel === 'undefined') {
    return
  }
  const channel = new BroadcastChannel(channelName)
  // oxlint-disable-next-line unicorn/require-post-message-target-origin -- a BroadcastChannel takes no target origin
  channel.postMessage({ source: thisTab })
  channel.close()
}

/** Calls `onChange` when another tab of this site changes who acts in the session. Returns the unsubscribe. */
export function listenForSessionChanges(onChange: () => void): () => void {
  if (typeof BroadcastChannel === 'undefined') {
    return () => undefined
  }
  const channel = new BroadcastChannel(channelName)
  channel.addEventListener('message', (event: MessageEvent<unknown>) => {
    if (sourceOf(event.data) !== thisTab) {
      onChange()
    }
  })
  return () => channel.close()
}

function sourceOf(data: unknown): unknown {
  return typeof data === 'object' && data !== null && 'source' in data ? data.source : undefined
}

/** Loads the page afresh. An object, so tests can watch it. */
export const pageReload = {
  now(): void {
    window.location.reload()
  },
}
